import lottie from 'lottie-web'

export class Lottie {
  constructor () {
    this.lotties = [...document.querySelectorAll('[data-lottie]')]
    this.animations = []
    this.init()
  }

  append (element) {
    const number = element.getAttribute('data-lottie')
    if (!number) { return false }

    const animation = lottie.loadAnimation({
      container: element,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: `/wp-content/themes/justdiggit2021/lotties/${number}.json`,
      rendererSettings: {
        preserveAspectRatio: false,
        viewBoxOnly: true
      }
    })

    this.animations.push(animation)
  }

  createObserver () {
    this.observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          const animation = this.animations.find(animation => { return animation.wrapper === entry.target })

          setTimeout(() => {
            animation.play()
          }, 250)

          this.observer.unobserve(entry.target)
        }
      })
    })

    this.animations.forEach(animation => {
      this.observer.observe(animation.wrapper)
    })
  }

  init () {
    this.lotties.forEach(element => {
      this.append(element)
    })

    this.createObserver()
  }
}
